import { render, staticRenderFns } from "./Extensions2_2.vue?vue&type=template&id=8eeace0a&scoped=true"
import script from "./Extensions2_2.vue?vue&type=script&lang=js"
export * from "./Extensions2_2.vue?vue&type=script&lang=js"
import style0 from "./Extensions2_2.vue?vue&type=style&index=0&id=8eeace0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eeace0a",
  null
  
)

export default component.exports